// extracted by mini-css-extract-plugin
export default {"container":"recentNews_container__3E6-o"};